exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navbar-wrapper[data-v-8c99b922] {\n  background: #ffffff;\n  -webkit-box-shadow: 0px 1px 2px rgba(30, 27, 34, 0.1);\n          box-shadow: 0px 1px 2px rgba(30, 27, 34, 0.1);\n  /* position: fixed; */\n}\n.project-name[data-v-8c99b922] {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 22px;\n  color: #979da5;\n}\n", ""]);

// exports
